import { Component, OnInit } from '@angular/core';
import { DashboardService } from 'src/app/services/dashboard.service';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.css'],
    standalone: false
})
export class HomeComponent implements OnInit {
  chart = [];
  dashboards = [];
  currentDashboard: any;

  constructor(public dashboardService: DashboardService) { }

  ngOnInit() {
    this.dashboardService.getTotalDashboardList("").subscribe(dashboards => {
      dashboards.forEach(d => {
        d.dashboardConfigs.forEach(dd => {
          dd['yearly'] = d.yearly
          dd['periodFilter'] = d['periodFilter']
          dd['rangeFilter'] = d['rangeFilter']
          dd['datePeriod'] = d['datePeriod']
          dd['dateRange'] = d['dateRange']
        })
      })
      this.dashboards = dashboards;
      this.currentDashboard = dashboards?.[0];
    })
  }

  currentIndex = 0;

  next(): void {
    if (this.currentIndex < this.dashboards.length - 1) {
      this.goTo(this.dashboards[++this.currentIndex]);
    }
  }

  prev(): void {
    if (this.currentIndex > 0) {
      this.goTo(this.dashboards[--this.currentIndex]);
    }
  }

  goTo(dashboard): void {
    this.currentIndex = this.dashboards.indexOf(dashboard);
    this.currentDashboard = null
    setTimeout(()=>{
      this.currentDashboard = Object.assign({}, dashboard);
        },50
    )
  }

}
